import React from 'react';

const CampoDeTexto = (props) => {
    const { item, actualmodule, pastvaluecorrect, pastvalueteachercomment, teacherquestion, autoSave, savedid, classbginput, pastvalue } = props.props
    const isApproved = pastvaluecorrect === true || pastvaluecorrect == 1;

    return <div className={'col'}>
        <div key={'questions' + item.id}>
            {actualmodule?.corrected &&
                <div className={'alert alert-light border mb-2'}>
                    {isApproved && <span className="badge badge-success mb-2">Respuesta aprobada</span>}
                    {!isApproved && <span className={'badge badge-danger mr-2'}>Incorrecto</span>}
                    {pastvalueteachercomment !== null && <span>{pastvalueteachercomment}</span>}
                    {teacherquestion !== null && <strong> - {teacherquestion}</strong>}
                </div>
            }

            <div data-type={1} className={'questionsfield'}>
                <textarea readOnly={isApproved && (actualmodule?.corrected === true || actualmodule?.corrected == 1)}
                    onBlur={isApproved ? null : autoSave}
                    onPaste={(e) => e.preventDefault()}
                    onCopy={(e) => e.preventDefault()}
                    onCut={(e) => e.preventDefault()}
                    onDrop={(e) => e.preventDefault()}
                    data-type={1} name={'field' + item.id} data-savedid={savedid} data-id={item.id}
                    data-approved={isApproved ? "1" : "0"}
                    required={isApproved ? null : 'required'} id={'fieldquestions' + item.id}
                    className={'fieldquestions form-control mb-3 ' + classbginput} defaultValue={pastvalue}></textarea>
            </div>
        </div>
    </div>
}

export default CampoDeTexto;